<template>
  <div class="pta-admin">
    <div class="page-titles border-bottom">
      <h3>Deals Section - Immediate Interface
        <span class="card-subtitle" v-if="clients">{{trans('general.total_result_found',{'count' : clients.total})}}</span>
        <span class="card-subtitle" v-else>{{trans('general.no_result_found')}}</span>
      </h3>
      <!-- <sort-by class="pull-right" :order-by-options="orderByOptions" :sort-by="filterClientForm.sort_by" :order="filterClientForm.order" @updateSortBy="value => {filterClientForm.sort_by = value}"  @updateOrder="value => {filterClientForm.order = value}"></sort-by>
      <button class="btn btn-info btn-sm pull-right m-r-10" v-if="!showFilterPanel" @click="showFilterPanel = !showFilterPanel"><i class="fas fa-filter"></i> <span class="d-none d-sm-inline">{{trans('general.filter')}}</span></button> -->
    </div>
    <div class="container-fluid p-20" style="font-size: 0.75em;">
      <div class="row">
        <div class="col-12">
          <transition name="fade">
            <div class="card border-bottom" v-if="showFilterPanel">
              <div class="card-body p-4">
                <h4 class="card-title">{{trans('general.filter')}}</h4>
                <div class="row">
                  <div class="col-6 col-sm-3">
                    <div class="form-group">
                      <label for="name">{{trans('investor.name')}}</label>
                      <input class="form-control" id="name" name="name" v-model="filterClientForm.name">
                    </div>
                  </div>
                  <div class="col-6 col-sm-3">
                    <div class="form-group">
                      <label for="email">{{trans('investor.contact_person')}}</label>
                      <input class="form-control" id="contact_person" name="contact_person" v-model="filterClientForm.contact_person">
                    </div>
                  </div>
                </div>
                <button class="btn btn-danger btn-sm pull-right" v-if="showFilterPanel" @click="showFilterPanel = !showFilterPanel">{{trans('general.cancel')}}</button>
              </div>
            </div>
          </transition>
          <transition name="fade" v-if="hasPermission('create-user')">
            <div class="card border-bottom" v-if="showCreatePanel">
              <div class="card-body p-4">
                <form @submit.prevent="submit" @keydown="investorForm.errors.clear($event.target.name)" autocomplete="off">
                  <div class="row">
                    <div class="col-12 col-sm-12">
                      <div class="row">
                        <div class="col-12 col-sm-3">
                          <div class="form-group">
                            <label for="">{{trans('investor.name')}}</label>
                            <input class="form-control" type="text" value="" v-model="investorForm.name" name="name" :placeholder="trans('investor.name')">
                            <show-error :form-name="investorForm" prop-name="name"></show-error>
                          </div>
                        </div>
                        <div class="col-12 col-sm-3">
                          <div class="form-group">
                            <label for="">{{trans('investor.contact_person')}}</label>
                            <input class="form-control" type="text" value="" v-model="investorForm.contact_person" name="contact_person" :placeholder="trans('investor.contact_person')" autocomplete="off">
                            <show-error :form-name="investorForm" prop-name="contact_person"></show-error>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button type="submit" class="btn btn-info waves-effect waves-light pull-right">{{trans('general.add')}}</button>
                  <button type="button" class="btn btn-danger waves-effect waves-light pull-right m-r-10" @click="showCreatePanel = !showCreatePanel">{{trans('general.cancel')}}</button>
                </form>
              </div>
            </div>
          </transition>
          <div class="card" v-if="clients.total">
            <div class="card-body">
              <div class="table-responsive" v-if="hasPermission('list-user') && clients.total">
                <table class="table table-hover">
                  <thead>
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Name of the client</th>
                    <th scope="col">Active Email Campaigns</th>
                    <th scope="col">Number of LP's active</th>
                    <th scope="col">Status (Intros Outstanding) % and No.</th>
                    <th scope="col" class="table-option">{{trans('general.action')}}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="client in clients.data">
                    <td v-text="client.id"></td>
                    <td v-text="client.profile.company"></td>
                    <td>0</td>
                    <td>{{ client.user_investors.length }}</td>
                    <td>0 / 0</td>
                    <td class="table-option">
                      <div class="btn-group">
                        <router-link :to="`/account/deals/${client.id}`" class="btn btn-info btn-sm" v-tooltip="'Show campains'"><i class="fas fa-arrow-circle-right"></i></router-link>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
             <pagination-record :page-length.sync="filterClientForm.page_length" :records="clients" @updateRecords="getClients"></pagination-record>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import switches from 'vue-switches'
import vSelect from 'vue-multiselect'
import dateRangePicker from '../../components/date-range-picker'
import sortBy from '../../components/sort-by'

export default {
  components: {switches,vSelect,dateRangePicker,sortBy},
  data() {
    return {
      showCreatePanel: false,
      clients: {
        total: 0,
        data: []
      },
      filterClientForm: {
        name: '',
        contact_person: '',
        sort_by : 'name',
        order: 'asc',
        page_length: 100
      },
      showFilterPanel: false,
      orderByOptions: [
        {
          value: 'name',
          translation: i18n.investor.name
        },
        {
          value: 'contact_person',
          translation: i18n.investor.contact_person
        },
        {
          value: 'created_at',
          translation: i18n.investor.created_at
        }
      ],
    };
  },
  mounted(){
    if(!helper.hasPermission('list-user') && !helper.hasPermission('create-user')){
      helper.notAccessibleMsg();
      this.$router.push('/account/dashboard');
    }   
    this.getClients();
  },
  methods: {
    hasPermission(permission){
      return helper.hasPermission(permission);
    },
    getClients(page){
      if (typeof page !== 'number') {
        page = 1;
      }
      let url = helper.getFilterURL(this.filterClientForm);
      axios.get('/api/user/deals?show=all&page=' + page + url)
          .then(response => response.data)
          .then(response => {
            this.clients = response;
          })
          .catch(error => {
            helper.showDataErrorMsg(error)
          });
    },
    confirmDelete(user){
      return dialog => this.deleteClient(user);
    },       
  },
  watch: {
    filterClientForm: {
      handler(val){
        this.getClients();
      },
      deep: true
    }
  },
  filters: {
    moment(date) {
      return helper.formatDate(date);
    }
  }
}
</script>
